export type DatabaseConnectionView = 'upstream' | 'downstream' | 'parameters'

export const DATABASE_CONNECTION_VIEWS: DatabaseConnectionView[] = [
  'upstream',
  'downstream',
  'parameters',
]

export function databaseConnectionBasePath(databaseId: string | number): string {
  return `/databases/${databaseId}/connection`
}

export function databaseConnectionPath(
  databaseId: string | number,
  view: DatabaseConnectionView = 'upstream',
): string {
  return `${databaseConnectionBasePath(databaseId)}/${view}`
}

export function databaseConnectionViewSegment(
  pathname: string,
  databaseId: string,
): DatabaseConnectionView | null {
  const prefix = `${databaseConnectionBasePath(databaseId)}/`
  if (!pathname.startsWith(prefix)) return null
  const rest = pathname.slice(prefix.length).replace(/\/$/, '')
  if (rest === 'upstream' || rest === 'downstream' || rest === 'parameters') return rest
  return null
}

export function isDatabaseConnectionPath(pathname: string, databaseId: string): boolean {
  const base = databaseConnectionBasePath(databaseId)
  return pathname === base || pathname.startsWith(`${base}/`)
}
